import {JournalEvent} from '../../events/events.models';
import {createActionGroup, emptyProps, props} from '@ngrx/store';
import type {HomeDashboardRecentChange, NearExpiryReportItem} from '../reports.models';

export type InventoryMutationEntity = 'container' | 'item';
export type InventoryMutationOperation = 'created' | 'updated' | 'deleted' | 'cloned' | 'writtenOff' | 'moved';

export const ReportsActions = createActionGroup({
  source: 'Reports',
  events: {
    'Account Changed': emptyProps(),
    'Application Started': props<{timeZoneId: string}>(),
    'Application Resumed': emptyProps(),
    'Effective Time Zone Changed': props<{timeZoneId: string}>(),
    'Inventory Mutation Completed': props<{
      entity: InventoryMutationEntity;
      entityId?: string;
      operation: InventoryMutationOperation;
    }>(),
    'Local Day Boundary Reached': emptyProps(),
    'Refresh Requested': emptyProps(),
    'Near Expiry Load Succeeded': props<{items: NearExpiryReportItem[]; localDate: string}>(),
    'Near Expiry Load Failed': props<{error: string}>(),
    'Recent Changes Load Succeeded': props<{recentChanges: HomeDashboardRecentChange[]; recentEvents?: JournalEvent[]}>(),
    'Recent Changes Load Failed': props<{error: string}>(),
  },
});
